import { getCurrencyCodeByCountry } from "../../Core/Util/Helpers"
export const generateProductReviewsStructuredData = (
   summaryReview,
   variantData,
   selectedChannelId
) => {

   if (!summaryReview?.your_avg_score || !summaryReview?.your_review_count) {
      return null;
   }

   if (!variantData) {
      return null;
   }

   const {
      title,
      articleNumber,
      brandName,
      currentPrice,
      images = [],
   } = variantData ?? {};

   let priceData = {};

   if (selectedChannelId) {
      priceData = {
         priceCurrency: getCurrencyCodeByCountry(selectedChannelId),
         price: currentPrice,
      };
   }

   let ReviewsStructureData = {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: title,
      image: images?.[0]?.url,
      // description: title,
      mpn: articleNumber,
      brand: {
         '@type': 'Brand',
         name: brandName,
      },
      aggregateRating: {
         '@type': 'AggregateRating',
         ratingValue: summaryReview.your_avg_score,
         reviewCount: summaryReview.your_review_count,
      },
      offers: {
         '@type': 'Offer',
         ...priceData,
         // availability: 'http://schema.org/InStock',
         seller: {
            '@type': 'Organization',
            name: 'Verktygsboden',
         },
      },
   };

   try {
      const structuredJSONData = JSON.stringify(ReviewsStructureData);
      return structuredJSONData;
   } catch (error) {
      // console.error("Error during JSON stringify:", error);
      return null;
   }
};


